import React from 'react';
import { ChevronLeft, Building2 } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const PrinterHeader = ({ 
  businessName, 
  wsStatus, 
  clientStatus 
}) => {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700">
      <div className="flex items-center p-4">
        <button 
          className="mr-4 text-gray-900 dark:text-white"
          onClick={() => navigate('/settings')}
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <div className="flex-1">
          <h1 className="text-xl font-bold text-gray-900 dark:text-white">Gestión de Impresoras</h1>
          <div className="flex items-center mt-1 text-sm text-gray-500 dark:text-gray-400">
            <Building2 className="w-4 h-4 mr-1" />
            <span>{businessName || 'Cargando...'}</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`px-2 py-1 rounded-full text-xs ${
            wsStatus === 'connected' 
              ? 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-400'
              : wsStatus === 'error'
                ? 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-400'
                : 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-400'
          }`}>
            {wsStatus === 'connected' ? 'Conectado' : wsStatus === 'error' ? 'Error' : 'Desconectado'}
          </span>
          <span className={`px-2 py-1 rounded-full text-xs ${
            clientStatus === 'running'
              ? 'bg-green-100 dark:bg-green-900/50 text-green-800 dark:text-green-400'
              : clientStatus === 'error'
                ? 'bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-400'
                : clientStatus === 'stopped'
                  ? 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-400'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
          }`}>
            Cliente: {
              clientStatus === 'running' ? 'Activo' :
              clientStatus === 'stopped' ? 'Detenido' :
              clientStatus === 'error' ? 'Error' :
              'Desconocido'
            }
          </span>
        </div>
      </div>
    </div>
  );
};

export default PrinterHeader; 